import React from 'react'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

const Modals = ({
  ModalHeader,
  btnName,
  secondBtnName,
  children,
  visible,
  setVisible,
  disabled,
  secondButtonDisabled,
  onButtonClick,
  onSecondButtonClick,
  loading,
  wait = false,
  hideButton = false,
  hideMainButton = false,
  width = '40rem',
  showDoNotShowAgain = false,
  onDoNotShowAgain = null,
  doNotShowAgainLabel = "Don't show again",
  onHide = null,
  severity = 'primary',
  btnClassName,
}) => {
  const footerContent = hideButton ? null : (
    <div className='d-flex justify-content-between w-100'>
      {showDoNotShowAgain && (
        <Button
          className='p-button-text p-button-secondary'
          label={doNotShowAgainLabel}
          onClick={() => {
            if (onDoNotShowAgain) {
              onDoNotShowAgain(true)
            }
            setVisible(false)
          }}
        />
      )}
      {!hideMainButton && (
        <div
          className={`${
            showDoNotShowAgain ? '' : 'd-flex justify-content-center w-100'
          }`}
        >
          <Button
            loading={loading}
            disabled={disabled ? disabled : false}
            label={btnName}
            onClick={() => {
              onButtonClick()
              if (!wait) {
                !disabled && setVisible(false)
              }
            }}
            className={
              btnClassName || (!severity ? 'p-button-outlined' : undefined)
            }
            severity={btnClassName ? undefined : severity}
          />
          {secondBtnName && (
            <Button
              loading={loading}
              disabled={disabled ? disabled : (secondButtonDisabled ? secondButtonDisabled : false)}
              label={secondBtnName}
              onClick={() => {
                if (onSecondButtonClick) {
                  onSecondButtonClick()
                }
              }}
              severity='primary'
            />
          )}
        </div>
      )}
    </div>
  )

  const handleHide = () => {
    if (onHide) {
      onHide()
    }
    setVisible(false)
  }

  return (
    <div className='card'>
      <Dialog
        header={ModalHeader}
        visible={visible}
        style={{ width: width }}
        breakpoints={{ '960px': '75rem', '641px': '90vw' }}
        onHide={handleHide}
        footer={footerContent}
      >
        {children}
      </Dialog>
    </div>
  )
}

export default Modals
